/** @module CollectionBook/PdfProduct */
define([
	"dojo/_base/declare",
	"csi/html/Widget",
	"csi/reflection",
	"csi/session"
], function(declare,HtmlWidget,reflection,session) {

	return declare(HtmlWidget, {
		imageSize: reflection.IMAGE_SIZE_LARGEST,

		/**
		 * @override
		 * Remove content that should not be shown based on the current sales product group
		 */
		onViewStart: function(dfds) {
			const self = this;
			const spgUrl = session.getLocationValue("SalesProductGroup");
			const dfd = this.cacheView.getNodeDeferred(spgUrl).then(function(spg) {
				if (spg) {
					self._removeKeyIf("RetailPrice", !spg.ShowRetailPrice);
					self._removeKeyIf("WholesalePrice", !spg.ShowWholesalePrice);
					self._removeKeyIf("HasPromo", !spg.ShowPromos);
				}
			});
			
			dfds.push(dfd);
		},
		
		/**
		 * Remove given key if condition is met
		 * @param {string} key
		 * @param {boolean} b
		 */
		_removeKeyIf: function(key, b) {
			if (b) {
				this.queryForKey(key).orphan();
			}
		}
	});
});